import { useEffect, useState } from 'react';
import useBranding from 'hooks/useBranding';
import { resolveDomainBranding, shouldSkipDomainBranding } from 'utils/domainBranding';

/**
 * Applies white-label branding to the DOM and loads firm branding from the
 * current hostname before login (e.g. texascorp.payrollnoot.com).
 */
const BrandingProvider = ({ children }) => {
    const [, setTick] = useState(0);
    const branding = useBranding();

    // Domain branding bootstrap (pre-login)
    useEffect(() => {
        let cancelled = false;
        (async () => {
            if (shouldSkipDomainBranding()) return;
            const result = await resolveDomainBranding();
            if (!cancelled && result) setTick((t) => t + 1);
        })();
        const onUpdate = () => setTick((t) => t + 1);
        window.addEventListener('branding-updated', onUpdate);
        return () => {
            cancelled = true;
            window.removeEventListener('branding-updated', onUpdate);
        };
    }, []);

    useEffect(() => {
        const root = document.documentElement;
        root.style.setProperty('--brand-primary', branding.primaryColor);
        root.style.setProperty('--brand-dark', branding.darkColor);
        root.style.setProperty('--brand-primary-light', branding.primaryColor + '18');
        root.style.setProperty('--brand-primary-border', branding.primaryColor + '40');
    }, [branding.primaryColor, branding.darkColor]);

    useEffect(() => {
        document.title = branding.productName;
    }, [branding.productName]);

    useEffect(() => {
        if (!branding.faviconUrl) return;
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = branding.faviconUrl;
    }, [branding.faviconUrl]);

    return children;
};

export default BrandingProvider;
